import _ from 'lodash';

// The status icon already carries a tooltip for expired pricing, but an ineligible program showed a bare red
// icon with no way to learn why — the reasons were only reachable by expanding the row (DEV-6519).
export const getEligibilityTooltip = ({
  isEligible,
  isProgramExpired,
  denialReasons = [],
  expiredMessage,
}) => {
  if (isProgramExpired) {
    return expiredMessage;
  }

  if (isEligible || !denialReasons.length) {
    return '';
  }

  // Count what is actually listed, not the raw array: a criterion carrying neither a name nor a reason
  // drops out of the list, and a header promising more reasons than it shows reads like a bug.
  const names = _.compact(
    denialReasons.map(({ criteriaName, denialReason }) => criteriaName || denialReason),
  );

  return [
    names.length > 1 ? `Not eligible — ${names.length} reasons` : 'Not eligible for this loan',
    ...names,
    'Expand for details',
  ].join('\n');
};
